import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Clock, FileWarning, Loader2, MapPin } from "lucide-react";
import { PdfViewer } from "../components/pdf/PdfViewer";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/* 免登录批准图纸页（分包通过分享链接打开）：只读 · 翻页 / 缩放 / 全屏 / 下载 · 到期自动失效。 */
export default function PlanShareView() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [zh, setZh] = useState(false);
  useEffect(() => {
    fetch(`${BACKEND}/api/public/plan/${token}`)
      .then(async (r) => { if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Link invalid or expired"); return r.json(); })
      .then(setData).catch((e) => setErr(e.message));
  }, [token]);
  useEffect(() => { if (data?.filename) document.title = `${data.filename} · ALIGCUS`; }, [data]);

  if (err) return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 text-center p-8" data-testid="plan-share-error">
      <FileWarning className="h-12 w-12 text-slate-600 mb-4" />
      <p className="text-slate-300 font-medium">{err}</p>
      <p className="text-slate-500 text-sm mt-1">This link is invalid or has expired — please ask the project manager for a new one.</p>
    </div>
  );
  if (!data) return <div className="min-h-screen flex items-center justify-center bg-slate-950"><Loader2 className="h-8 w-8 text-brand-500 animate-spin" /></div>;
  const exp = data.expiresAt ? new Date(data.expiresAt).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : null;
  return (
    <div className="h-[100dvh] flex flex-col bg-slate-950 text-slate-100" data-testid="plan-share-page">
      <header className="flex items-center gap-3 px-3 sm:px-5 h-14 shrink-0 border-b border-white/10">
        <span className="font-black tracking-tight text-brand-400 text-sm sm:text-base">ALIGCUS</span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold truncate" data-testid="plan-share-title">{data.filename}</p>
          <p className="text-[11px] text-slate-400 truncate flex items-center gap-2">
            <span className="uppercase tracking-wider text-[10px] font-semibold text-slate-500">{zh ? "批准图纸" : "Approved Plan"}</span>
            {data.address && <span className="inline-flex items-center gap-1 truncate" data-testid="plan-share-address"><MapPin className="h-3 w-3 shrink-0" />{data.address}</span>}
            {exp && <span className="hidden sm:inline-flex items-center gap-1 shrink-0" data-testid="plan-share-expiry"><Clock className="h-3 w-3" />{zh ? "有效至" : "Valid until"} {exp}</span>}
          </p>
        </div>
        <button type="button" onClick={() => setZh((v) => !v)} className="text-[11px] text-slate-400 hover:text-white border border-white/10 rounded-md px-2 h-7" data-testid="plan-share-lang">{zh ? "EN" : "中文"}</button>
      </header>
      <main className="flex-1 min-h-0 p-0 sm:p-3">
        <PdfViewer meta={data} zh={zh} tp="plan" downloadUrl={`${BACKEND}/api/public/plan/${token}/download`} pageUrl={(n, s) => `${BACKEND}/api/public/plan/${token}/page/${n}?size=${s}`} />
      </main>
    </div>
  );
}
